import { CARD_IMAGE_RATIO_OPTIONS } from '../app-ui-settings/catalog.js';
export const LIST_IMAGE_ASPECT_RATIO_OPTIONS = CARD_IMAGE_RATIO_OPTIONS;
export const MEDIA_DEFAULT_PAYLOAD = { listImage: { aspectRatio: '3:4' } };
const isTree = (value) => typeof value === 'object' && value !== null && !Array.isArray(value);
const isAspectRatio = (value) => LIST_IMAGE_ASPECT_RATIO_OPTIONS.some((option) => option.value === value);
export function aspectRatioValue(ratio) {
    const [width, height] = ratio.split(':').map(Number);
    return (width ?? 3) / (height ?? 4);
}
export function validateMediaPayload(payload) {
    if (!isTree(payload))
        return { ok: false, errors: ['component.media: must be an object'] };
    const errors = [];
    for (const key of Object.keys(payload))
        if (key !== 'listImage')
            errors.push(`${key}: unknown field`);
    const listImage = payload['listImage'];
    if (listImage !== undefined) {
        if (!isTree(listImage))
            errors.push('listImage: must be an object');
        else
            for (const [key, value] of Object.entries(listImage)) {
                if (key !== 'aspectRatio')
                    errors.push(`listImage.${key}: unknown field`);
                else if (!isAspectRatio(value))
                    errors.push(`listImage.aspectRatio: one of ${LIST_IMAGE_ASPECT_RATIO_OPTIONS.map((o) => o.value).join(', ')}`);
            }
    }
    return errors.length
        ? { ok: false, errors }
        : { ok: true, payload: payload, errors };
}
export function mergeMediaPayload(builtIn, received) {
    if (!isTree(received))
        return null;
    const receivedRatio = isTree(received['listImage'])
        ? received['listImage']['aspectRatio']
        : undefined;
    const builtInRatio = builtIn.listImage?.aspectRatio;
    const aspectRatio = isAspectRatio(receivedRatio)
        ? receivedRatio
        : isAspectRatio(builtInRatio)
            ? builtInRatio
            : '3:4';
    return { listImage: { aspectRatio } };
}
//# sourceMappingURL=media.js.map